import styled from 'styled-components'

export const StyledMakeReview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-inline: ${props => props.theme.spacing.xxlarge};
`

export const MakeReviewStart = styled.div`
  display: flex;
  padding-block: ${props => props.theme.spacing.large};
  gap: ${props => props.theme.spacing.medium};
  color: rgba(255, 181, 65, 1);
`
